<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/sellOn_list',title:'市场预测'},{title:'内销预测修改'}]"/>
        <div class="h-content">
            <div class="h-table h-mrt30 ljjtablepaddings7">
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%">
                    <el-table-column
                            fixed
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="customer"
                            label="客户名称"
                            width="200"
                            :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div style="text-align: left;">{{scope.row.customer}}</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="trench"
                            label="渠道"
                            width="100">
                        <template slot-scope="scope">
                            <brselect placeholder="请选择"
                                      category="sales_region"
                                      :v="scope.row.trench"
                                      v-model="scope.row.trench"
                                      class="h-tableInput">
                            </brselect>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="targetUser"
                            label="目标用户"
                            width="120">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.targetUser" placeholder="请输入"
                                      class="h-tableInput"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="productType"
                            label="产品大类"
                            width="150">
                        <!--<template slot-scope="scope">
                            &lt;!&ndash;                        {{scope.row.productType?scope.row.productType:'选择型号自动生成'}}&ndash;&gt;
                            <el-select v-model="scope.row.productType" placeholder="请选择"
                                       @change="showModelCode(scope.row)" class="h-tableInput" filterable>
                                <el-option
                                        v-for="(item,index) in opt"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                            prop="productModel"
                            label="型号"
                            width="170">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.productModel}}
								    </div>
								</template>
                        <!--<template slot-scope="scope">
                            <el-select v-if="showModel1" v-model="scope.row.productModel" placeholder="请选择"
                                       @change="selectChange(scope.row)" class="h-tableInput" filterable>
                                <el-option
                                        v-for="(item,index) in options"
                                        :key="index"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                            <div v-if="showModel2" @click="clickmodel(scope.row)">
                                {{scope.row.productModel?scope.row.productModel:'点击选择'}}
                            </div>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                            prop="num"
                            label="数量"
                            width="100">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.num" @change="changeNum(scope.row)" placeholder="0"
                                      class="h-tableInput"
                                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                      onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="price"
                            label="单价(元)"
                            width="100"
                            :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.price}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="totalSales"
                            label="总销额(元)"
                            width="120"
                            :show-overflow-tooltip="true">
                        <template scope="scope"><div style="text-align: right;">{{scope.row.totalSales}}</div></template>
                    </el-table-column>
                    <el-table-column
                            prop="income"
                            label="收入(元)"
                            width="180"
                            :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.income}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="formationTime"
                            label="预计成单日期"
                            width="180">
                        <template slot-scope="scope">
                        <el-date-picker
                                v-model="scope.row.formationTime"
                                type="date"
                                class="h-tableInput"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择时间"
                                @change="changeTime(scope.row,scope.$index)">
                        </el-date-picker>
                    </template>
                    </el-table-column>
                    <el-table-column
                            prop="week"
                            label="第几周"
                            width="150"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <div>{{scope.row.week}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="orderType"
                            label="订单类型"
                            width="140">
                        <template slot-scope="scope">
                            <brselect category="yuce_type" :v="scope.row.orderType" v-model="scope.row.orderType"
                                      class="h-tableInput"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="false"
                            prop="tax">
                    </el-table-column>
                    <!--<el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text"
                                       size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
                <!--<div class="h-tableAdd" @click="add">
                    <a>新增一行</a>
                </div>-->
                <div class="h-tableSummary">
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">履约率</span>
                        <span v-if="showNum" style="color: #c61c1c;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-redFont">警示（0%）</span>
                        <span v-if="showGreen" style="color: #21d06f;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-greenFont">履约（{{numb}}%） </span>
                        <span v-if="showBlue" style="color: #2785e7;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-blueFont">达标（{{numb}}%）</span>
                        <span v-if="showRed" style="color: #c61c1c;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-redFont">警示（{{numb}}%）</span>
                    </div>
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">签约目标</span>
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">{{target}}万</span>
                    </div>
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">销单预测金额</span>
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">{{totalMon}}万</span>
                    </div>
                </div>
                <!--<div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="uploaddownexcelflagbtn">批量导入</el-button>
                        <uploaddownexcel
                                :visible.sync="uploaddownexcelflag"
                                v-if="uploaddownexcelflag"
                                clsname="neiXiaoYuCeImportExcel"
                                :startrow="3"
                                @callback="uploadExcelFilecallback"/>
                    </div>
                </div>-->
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
                <!--<el-button class="h-btn h-bBtn h-bggreen" @click="saveTo">暂存</el-button>-->
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="subTo">确认提交</el-button>
            </div>
            <!--<div>
                <el-dialog :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>产品价格信息</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f"
                                 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                <el-select v-model="f.productModel" placeholder="&#45;&#45;请选择产品型号&#45;&#45;"
                                           @change="selectAllPrice(f.productModel)" class="h-tableInput" filterable>
                                    <el-option
                                            v-for="(item,index) in options"
                                            :key="index"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="产品价格" class="h-elformWrap-2">
                                <el-select v-model="f.price" placeholder="&#45;&#45;请选择产品价格&#45;&#45;"
                                           class="h-tableInput" @change="changemodel">
                                    <el-option
                                            v-for="(item,index) in prices"
                                            :key="index"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" type="primary" @click="decide">确定</el-button>
                    </div>
                </el-dialog>
            </div>-->
        </div>
    </div>
</template>

<script>
    import big from 'big.js'
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components:{
            uploaddownexcel,
        },
        name: 'leftMenu',
        data() {
            return {
                //查询属性
                istrue: false,
                q: {
                    bid: '',
                    formationTimeLike: '',
                    cucode: ''
                },
                //表单
                formInline: {
                    pageSize: 20,
                    pageNo: 1,
                    total: 0,
                },
                f: {
                    productModel: '',
                    price: ''
                },
                //表格
                tableData: [],
                totalMon: 0,
                tot: 0,
                a: 0,
                choseModel: '点击选择',
                options: [],
                model: '',
                opt: [],
                prices: [],
                colorControl: '',
                uploaddownexcelflag: false,
                dialogFormVisible: false,
                showGreen: false,
                showBlue: false,
                showRed: false,
                showNum: true,
                showModel1: false,
                showModel2: false,
                uName: '',
                target: '',
                numb: '',
                month: '',
                items: {}
            }
        },
        mounted() {
        },
        created() {
            this.showTarget();
            this.showLevName();
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/yuce/sellOn_list' && from.path == '/yuce/yuceRevise'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            uploadExcelFilecallback(rd){
                this.showList();
            },
            uploaddownexcelflagbtn(){
                this.uploaddownexcelflag = true;
            },
            getMonthWeek(v) {
                if (v.formationTime) {
                    let currentDay = new Date(v.formationTime);
                    // console.info(currentDay); // 2019-05-07T07:36:00.883Z
                    // 获取该日期所在周的周六，如2019.5月的周六有4号、11号、18号、25号、31号
                    let theSaturday = currentDay.getDate() + (6 - currentDay.getDay());
                    var cNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
                    var ll = Math.ceil(theSaturday / 7);
                    v.week = "第"+cNum[ll]+"周";
                } else {
                    v.week = '';
                }
            },
            showModelCode(v) {
                v.productModel = '';
                this.selectModel(v.productType);
            },
            clickmodel(item) {
                this.items = item;
                if (this.items.productModel) {
                    this.f.productModel = this.f.productModel;
                    this.f.price = this.f.price;
                } else {
                    this.f.productModel = '';
                    this.f.price = ''
                }
                this.dialogFormVisible = true;
            },
            changemodel(v) {
                this.items.price = v;
            },
            decide() {
                this.prices = [];
                this.f.price = this.items.price;
                this.f.productModel = this.items.productModel;
                this.dialogFormVisible = false;
                this.model = this.items.productModel
                // ss.pingshen.showType(this.code).then(rd => {
                //     this.items.productType = rd
                // });
                this.changeNum(this.items);

            },
            selectAllPrice(v) {
                this.items.productModel = v;
                this.f.price = '';
                this.prices = [];
                ss.pingshen.selectPrice(v).then(rd => {
                    this.prices = rd;
                })
            },
            showTarget() {
                var ucode = this.$route.query.userCode
                ss.pingshen.showTarget(ucode).then(rd => {
                    if (rd) {
                        this.target = rd;
                    } else {
                        this.target = 0;
                    }
                    this.showList();
                })
            },
            changeTime(v) {
                var date1 = v.formationTime.substring(0, 7);
                // var date2 = this.getyyyyMM();
                var date2 = this.month;
                var d = date2.split("-");
                if (date1 != date2) {
                    this.$msg.alerte("您只能选择"+d[0]+"年"+d[1]+"月"+"的日期!", this.empDate(v), "fn2");
                }
                this.getMonthWeek(v);
            },
            empDate(v) {
                v.formationTime = '';
            },
            //获取下个月月份的方法
            getyyyyMM() {
                const date = new Date();
                var year = date.getFullYear(); //获取当前日期的年份
                var month = date.getMonth() + 1; //获取当前日期的月份
                var year2 = year;
                var month2 = parseInt(month) + 1;
                if (month2 == 13) {
                    year2 = year + 1;
                    month2 = 1
                }
                if (month2 < 10) {
                    month2 = "0" + month2;
                }
                var t2 = year2 + "-" + month2;
                return t2;
            },
            add() {
                this.istrue = true;
                var list = {
                    customer: this._user.username,
                    trench: '',
                    targetUser: '',
                    productType: '',
                    productModel: '',
                    num: '',
                    price: '',
                    totalSales: '',
                    income: '',
                    formationTime: '',
                    orderType: '',
                    week:''
                }
                this.tableData.push(list);
            },
            deleteRow(index, rows) {
                this.$msg.confirm("确认删除?", () => {
                    rows.splice(index, 1);
                    this.tot = 0;
                    this.tableData.forEach((item, index) => {
                        this.tot = new big(this.tot).plus(item.totalSales);
                    })
                    this.totalMon = this.tot;
                    this.totalMon = this.totalMon.div(10000);
                    if (this.target == 0) {
                        this.numb = 100;
                    } else {
                        this.numb = this.totalMon.div(this.target);
                        this.numb = this.numb.times(100);
                    }
                    if (this.numb < 70) {
                        this.showRed = true;
                        this.showBlue = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 70 && this.numb < 100) {
                        this.showBlue = true;
                        this.showRed = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 100) {
                        this.showGreen = true;
                        this.showBlue = false;
                        this.showRed = false;
                        this.showNum = false;
                    }
                })
            },
            showList() {
                if (this.$route.query.ywid) {
                    this.q.bid = this.$route.query.ywid;
                } else {
                    this.q.bid = this.$route.query.bid;
                }
                this.q.formationTimeLike = this.$route.query.month;
                this.q.cucode = this.$route.query.userCode;
                this.month = this.$route.query.mon;
                if (this._user.usertype == 1) {
                    this.showModel1 = true;
                    this.showModel2 = false;
                } else {
                    this.showModel1 = false;
                    this.showModel2 = true;
                }
                ss.pingshen.showList(this.q).then(rd => {
                    this.tableData = rd;
                    this.totalMon = 0;
                    if (this.tableData.length == 0) {
                        this.add();
                    } else {
                        this.tableData.forEach((item, index) => {
                            ss.pingshen.selectTax(item.productModel).then(rd => {
                                item.tax = rd;
                            })
                        })
                    }
                    this.tableData.forEach((item, index) => {
                        this.totalMon = new big(parseInt(this.totalMon)).plus(parseInt(item.totalSales));
                    })
                    this.totalMon = new big(this.totalMon).div(10000);
                    this.uName = this._user.username;
                    this.formInline.area = this._user.area;
                    //将签约目标变成万
                    this.target = new big(this.target).div(10000);
                    if (parseInt(this.target) == 0 ) {
                        this.numb = 100
                    } else {
                        this.numb = this.totalMon.div(this.target);
                        this.numb = this.numb.times(100);
                        this.numb = this.numb.toFixed(2);
                    }

                    if (this.numb < 70) {
                        this.showRed = true;
                        this.showBlue = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 70 && this.numb < 100) {
                        this.showBlue = true;
                        this.showRed = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 100) {
                        this.showGreen = true;
                        this.showBlue = false;
                        this.showRed = false;
                        this.showNum = false;
                    }
                })
            },
            subTo() {
                var f = true;
                // var a = 0;
                this.$msg.confirm("确认提交?", () => {
                    b:
                    for (var s = 0; s < this.tableData.length; s++) {
                        for (var c in this.tableData[s]) {
                            if (this.tableData[s][c] == "" && (c == 'trench' || c == 'targetUser' || c == 'num'
                                || c == 'formationTime' || c == 'orderType')) {
                                console.log("这个是空: "+ c);
                                this.$msg.msge("您的数据有未填项,请填写数据!");
                                f = false;
                                break b;
                            }
                        }
                    }
                    if (f) {
                        ss.pingshen.submitRevise(this.tableData).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.$router.push({path: "/yuce/sellOn_list"});
                        });
                    }
                })
            },
            returnTable() {
                this.$router.push({path: "/yuce/sellOn_list"});
            },
            selectModel(v) {
                ss.pingshen.showModel(v).then(rd => {
                    this.options = rd;
                })
            },
            showLevName() {
                ss.pingshen.showLName().then(rd => {
                    this.opt = rd;
                })
            },
            selectChange(v) {
                this.model = v.productModel
                // ss.pingshen.showType(this.code).then(rd => {
                //     v.productType = rd
                // });
                ss.pingshen.showPrice(this.model).then(rd => {
                    if (rd.f == true) {
                        v.price = rd.obj;
                        v.totalSales = new big(v.num).times(rd.obj);
                        v.income = new big(v.totalSales).div(1.13);
                        v.income = v.income.toFixed(2);
                        this.tot = 0;
                        this.tableData.forEach((item, index) => {
                            this.tot = new big(this.tot).plus(item.totalSales);
                        })
                        this.totalMon = this.tot;
                        this.totalMon = new big(this.totalMon).div(10000);
                        if (this.target == 0) {
                            this.numb = 100;
                        } else {
                            this.numb = this.totalMon.div(this.target);
                            this.numb = this.numb.times(100);
                        }
                    } else {
                        this.$msg.msge(rd.msg);
                        v.productModel = '';
                    }
                    if (this.numb < 70) {
                        this.showRed = true;
                        this.showBlue = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 70 && this.numb < 100) {
                        this.showBlue = true;
                        this.showRed = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 100) {
                        this.showGreen = true;
                        this.showBlue = false;
                        this.showRed = false;
                        this.showNum = false;
                    }
                });
            },
            changeNum(v) {
                v.totalSales = new big(v.num).times(v.price);
                if (parseInt(v.tax) == 0) {
                    v.income = new big(v.totalSales).div(1);
                } else if (parseInt(v.tax) == 2 || parseInt(v.tax) == 3 || parseInt(v.tax) == 4) {
                    v.income = new big(v.totalSales).div(1.13);
                } else if (parseInt(v.tax) == 7) {
                    v.income = new big(v.totalSales).div(1.06);
                } else {
                    v.income = new big(v.totalSales).div(1.13);
                }
                v.income = v.income.toFixed(2);
                this.tot = 0;
                this.tableData.forEach((item, index) => {
                    this.tot = new big(this.tot).plus(item.totalSales);
                })
                this.totalMon = this.tot;
                this.totalMon = new big(this.totalMon).div(10000);
                if (this.target == 0) {
                    this.numb = 100;
                } else {
                    this.numb = this.totalMon.div(this.target);
                    this.numb = this.numb.times(100);
                }
                if (this.numb < 70) {
                    this.showRed = true;
                    this.showBlue = false;
                    this.showGreen = false;
                    this.showNum = false;
                }
                if (this.numb >= 70 && this.numb < 100) {
                    this.showBlue = true;
                    this.showRed = false;
                    this.showGreen = false;
                    this.showNum = false;
                }
                if (this.numb >= 100) {
                    this.showGreen = true;
                    this.showBlue = false;
                    this.showRed = false;
                    this.showNum = false;
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 0.6rem;
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;;
    }

</style>
<style>
	.ljjtablepaddings7 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings7 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>